import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.module.scss';

export default class Image extends Component {

	render() {
		let {src, hover, onClick, style, className} = this.props;
		return (
			<img
				className={classNames(onClick ? styles.image : null, className)}
				alt={""}
				src={src}
				onMouseOver={e => (e.currentTarget.src = hover)}
				onMouseOut={e => (e.currentTarget.src = src)}
				onClick={onClick}
				style={style}
			/>
		);
	}
}

Image.propTypes = {
	src: PropTypes.string.isRequired,
	hover: PropTypes.string,
	onClick: PropTypes.func,
	style: PropTypes.object
};